import Vue from 'vue';
import { Image } from 'vant';
import App from './App';
import router from './router';
// eslint-disable-next-line no-unused-vars
import vsApi from './lib/http/index';
// eslint-disable-next-line no-unused-vars
import sensors from './lib/sensors';
import Util from "./util";

// import "vant/lib/image/index.css";
// import "vant/lib/field/index.css";
import "vant/lib/index.css";



// window.brand = 'masterkongchef';
// window.brand = 'dicos';

Vue.use(Image);

Vue.config.productionTip = false;
Vue.prototype.$pxToVw = px => (px === 0 ? 0 : `${px / 750 * 100}vw`);
Vue.prototype.$isHideNavbar = Util.isHideNavBar();
try {
  console.log("APP_Version:", process.env.ENV_DATA.APP_VERSION);
} catch (e) {
  console.log("");
}

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
